export const constants = {
  mobileBreakpoint: 600,
  textAreaMaxHeight: 250,
  textAreaMaxCharacterLimit: 3000,
  commentMaxCharacterLimit: 500,
  participantModalMaxHeight: 470,
  participantModalMaxHeightInPercentage: 0.9,
  confirmModalMaxHeight: 470,
  confirmModalMaxHeightInPercentage: 0.9,
  premiumUserPrice: 20.16,
  premiumUserVat: 3.84,
  freeImages: 3, 
  defaultChoiceConfig: {
    "nameOfQuestion": "",
    "main_answers": [
      {
        "symbol_name": "checked",
        "label": "yes",
        "isCompulsory": true,
        "isUsedInPoll": true
      },
      {
        "symbol_name": "crossed",
        "label": "no",
        "isCompulsory": true,
        "isUsedInPoll": true
      },
      // {
      //   "symbol_name": "checked with parenthesis",
      //   "label": "If need be",
      //   "isCompulsory": false,
      //   "isUsedInPoll": { "code": "use", "label": "Use" }
      // },
      // {
      //   "symbol_name": "question",
      //   "label": "dont know yet",
      //   "isCompulsory": false,
      //   "isUsedInPoll": { "code": "doNotUse", "label": "Do not use" },
      // }      
    ],
    "additional_answers": [
    ]
  }
};
